import React from 'react';
import { Box, Grid } from '@forgeglobal/design-framework';
import MainDisclaimer from '@tcs/common/components/atoms/footer/MainDisclaimer';
import Header from './Header';

interface FixedLayoutProps {
  children: React.ReactNode;
  shouldShowUser?: boolean;
  className?: string;
  hideDisclaimer?: boolean;
}

const FixedLayout = ({
  children,
  shouldShowUser,
  hideDisclaimer = false,
}: FixedLayoutProps) => {
  return (
    <Box sx={{ height: '100vh' }}>
      <Header shouldShowUser={shouldShowUser} fixed />
      <Grid container>
        {children}
        {!hideDisclaimer && <MainDisclaimer />}
      </Grid>
    </Box>
  );
};

export default FixedLayout;
